import type { BlockExportMapping } from "@circle-react-shared/BuilderUI/BuilderUI.types";
import { ProductCardBlock } from "./ProductCard";
import { ProductShot1Block } from "./ProductShot1";

export const productShotBlocks: BlockExportMapping = {
  ProductCard: ProductCardBlock,
  ProductShot1: ProductShot1Block,
};
